import { render, staticRenderFns } from "./NoProviders.vue?vue&type=template&id=12ed8826&"
import script from "./NoProviders.vue?vue&type=script&lang=js&"
export * from "./NoProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports